<template>

    <div class="container-fluid">
        <div class="row my-2">
            <div class="col-md-12">
                <h2 class="page-header">Transfer of Services</h2>
                <p>Please insert the Switch Telecom account number of the existing Switch Telecom client that you would like to transfer services from. (If you are not sure what the existing account number is, please confirm the details with the company or individual that you are transferring the solution(s) from)</p>

                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th colspan="2">Account details</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th><label class="required">Account Number</label></th>
                                <td>
                                    <div class="form-group" :class="{error: $v.serviceTransfer.clientZoneAccountNumber.$error}">
                                        <input type="text" class="form-control" placeholder="Please enter your Switch Telecom account number" v-model="serviceTransfer.clientZoneAccountNumber"/>
                                        <p class="help-block" v-if="$v.serviceTransfer.$error && !$v.serviceTransfer.clientZoneAccountNumber.required"><i class="fas fa-exclamation-triangle"></i> Please enter the account number.</p>
                                        <p class="help-block" v-if="$v.serviceTransfer.$error && !$v.serviceTransfer.clientZoneAccountNumber.isValidAccountNumber"><i class="fas fa-exclamation-triangle"></i> Invalid account number entered. Please confirm as per instructions above.</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th><label class="required">Do you want to transfer all services or partial services</label></th>
                                <td colspan="2">
                                    <div class="form-group" :class="{error: $v.serviceTransfer.partialTransfer.$error}">
                                        <!-- First -->
                                        <label for="all-services" class="option-input-label"><input type="radio" class="option-input with-check radio" id="all-services" :value="false" v-model="serviceTransfer.partialTransfer" />
                                        All services</label>

                                        <!-- Second -->
                                        <label for="partial-services" class="option-input-label"><input type="radio" class="option-input with-check radio" id="partial-services" :value="true"  v-model="serviceTransfer.partialTransfer">
                                        Partial services</label>
                                        <p class="help-block" v-if="$v.serviceTransfer.$error && !$v.serviceTransfer.partialTransfer.required"><i class="fas fa-exclamation-triangle"></i>  Please select an option.</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                <div class="actions d-flex" :class="allowPrevStep ? 'justify-content-between' : 'justify-content-end'">
                    <button type="button" class="btn btn-dark" @click="prevStep()" v-if="allowPrevStep"><i class="fas fa-angle-left"></i> Previous</button>
                    <button type="button" class="btn btn-dark" @click="nextStep()" :disabled="validationFailed || isBtnLoading">Next <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin"  v-if="isBtnLoading"></i></button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import { required } from 'vuelidate/lib/validators'
const accountRegex = /^[Aa][0-9]{5}$/;

export default {
    name: "TransferServices",
    
    props: {
        serviceTransfer: {
            type: Object,
            required: true
        },
        allowPrevStep: {
            type: Boolean,
            required: true
        },
    },

    data() {
        return {
            isBtnLoading: false,
        };
    },

    validations:{
        serviceTransfer: {
            clientZoneAccountNumber: {
                required,
                isValidAccountNumber: function(account){
                    return accountRegex.test(account); 
                }
            },
            partialTransfer: {
                required,
            }
        },
    },

    computed: {
        /* Validation */
        validationFailed: function(){
            return this.$v.serviceTransfer.$error === true;
        }
    },

    methods: {
        prevStep: function () {
            this.$emit('prevStep');
        },
        
        nextStep: function () {
            this.isBtnLoading = true;

            //We validate
            this.$v.serviceTransfer.$touch();

            if (this.$v.serviceTransfer.$invalid) {
                this.isBtnLoading = false;
                //scrollToError('form-group');
                return;
            }

            //Let's ensure the account number is capitalized
            this.serviceTransfer.clientZoneAccountNumber = (this.serviceTransfer.clientZoneAccountNumber).toUpperCase();

            this.$emit('nextStep');
        },
    }
};
</script>